export interface IEICFConsent {
    id: number;
    patientID: number;
    patientName?: string | null;
    healthcareFacilityID: number;
    eicfTemplateID: number;
    templateNameEn?: string | null;
    templateNameFr?: string | null;
    templateVersion: number;
    templateRawJson?: string | null;
    templateThemeJson?: string | null;
    templateKind?: string | null; // "SurveyJson" | "FillablePdf"
    templateFieldConfigJson?: string | null; // per-field roles/required (FillablePdf only)
    templateDocumentUrl?: string | null; // presigned GET for the sponsor PDF (FillablePdf only)
    signedPdfUrl?: string | null; // presigned GET for the stored signed PDF (FillablePdf only)
    status: string;
    answersJson?: string | null;
    patientSignedDate?: string | null;
    physicianUserID?: number | null;
    physicianName?: string | null;
    physicianSignedDate?: string | null;
    refusalReason?: string | null;
    createdDate: string;
    hasAssistantConfigured: boolean;
}

export interface ISubmitEICFSignatureRequest {
    consentID: number;
    answersJson: string;
    signedPdfS3Key?: string;
}

export interface IRefuseEICFConsentRequest {
    consentID: number;
    reason: string;
}

export const EICFConsentStatus = {
    PendingPatientSignature: 'PendingPatientSignature',
    PendingPhysicianSignature: 'PendingPhysicianSignature',
    Signed: 'Signed',
    Refused: 'Refused',
} as const;

export const EICFConsentTemplateKind = {
    SurveyJson: 'SurveyJson',
    FillablePdf: 'FillablePdf',
} as const;
